import { Results } from '../results.model';
import { cloneDeep } from 'lodash-es';
import { ScenarioInput } from './scenario-input.model';

export interface ScenarioInterface {
  name: string;
  inputs: ScenarioInput[];
  results?: Results;
  'project-state': any;
  _id: string;
  enableProductSliders: boolean;
}

export class Scenario {
  public name: string;
  public inputs: ScenarioInput[];
  public results?: Results;
  public 'project-state';
  public _id: string;
  enableProductSliders: boolean;

  constructor(param: ScenarioInterface = {
    name: '',
    inputs: [],
    'project-state': null,
    _id: undefined,
    enableProductSliders: false,
  }) {
    if (param.results) {
      this.results = new Results(param.results);
    }
    this.name = param.name;
    this.inputs = [];
    if (param.inputs && param.inputs.length > 0) {
      for (const input of param.inputs) {
        this.inputs.push(new ScenarioInput(input));
      }
    }
    this['project-state'] = param['project-state'];
    this._id = param._id;
    this.enableProductSliders = param.enableProductSliders;
  }

  deepCopy() {
    return new Scenario(cloneDeep(this));
  }

  /**
   * Returns a duplicate of this class with the name & id removed. Used to create
   * duplicate scenarios. All scenario inputs are also duplicated as well.
   */
  duplicate(): Scenario {
    const dupe = this.deepCopy();
    dupe.name = '';
    dupe._id = undefined;
    const itemsDupe = [];
    for (const input of this.inputs) {
      itemsDupe.push(input.duplicate());
    }
    dupe.inputs = itemsDupe;
    return dupe;
  }
}
